import React from 'react';
import { Field } from 'react-final-form';
import { useIntl } from 'ha/i18n';
import Track from 'ha/components/track/SmartTrack';
import PasswordField from 'ha/components/next/FormFields/final-form/PasswordField';
import TextField from 'ha/components/next/FormFields/final-form/TextField';
import { FormLabel, Grid } from '@ha/dsl';

const LoginFields: React.FC = () => {
  const { T } = useIntl();

  return (
    <React.Fragment>
      <Grid item>
        <FormLabel required>{T('E-mail address')}</FormLabel>
        <Track name="Selected Email" type="field">
          <Field
            id="email"
            name="email"
            type="email"
            placeholder={T('Enter E-mail')}
            component={TextField}
            required
            fullWidth
            data-test-locator="Email Input"
          />
        </Track>
      </Grid>

      <Grid item>
        <FormLabel required>{T('Password')}</FormLabel>
        <Track name="Selected Password" type="field">
          <Field
            id="password"
            name="password"
            placeholder={T('Enter Password')}
            component={PasswordField}
            required
            fullWidth
            data-test-locator="Exposable Password Input"
          />
        </Track>
      </Grid>
    </React.Fragment>
  );
};

export default LoginFields;
